import { usePartner } from 'components/app/routes/usePartner';

export const useIsEmailQuoteQualified = () => {
  const { isDSJourney } = usePartner();

  return isDSJourney;
};
